var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import StageDomainService from "../Domain/Stage/Stage.service";
const BASE_URL = "/aviso/stage";
export default class StageService {
    static get(stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                id: stageId,
            });
        });
    }
    static delete(stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.deleteSingleResponse(BASE_URL + "/delete", {
                id: stageId,
            });
        });
    }
    static create(stageCreateRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/create", {
                name: stageCreateRequest.name,
                description: stageCreateRequest.description,
                stageTypeId: stageCreateRequest.stageTypeId,
                pipelineId: stageCreateRequest.pipelineId,
            });
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                stageIds: search.stageIds,
                notStageIds: search.notStageIds,
                pipelineIds: search.pipelineIds,
                workflowGroupIds: search.workflowGroupIds,
                positions: search.positions,
                stageTypeIds: search.stageTypeIds,
                query: search.query,
                createDateFrom: search.createDateFrom,
                createDateTo: search.createDateTo,
                modifiedDateFrom: search.modifiedDateFrom,
                modifiedDateTo: search.modifiedDateTo,
                searchText: search.searchText,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, resp), { data: resp.data.map(StageDomainService.fromJSON) });
        });
    }
    static edit({ stageId, validationRules, name, description, position, stageTypeId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/edit", {
                stageId,
                validationRules,
                name,
                description,
                position,
                stageTypeId,
            });
        });
    }
    static changeDisplayOrder(stageIds, positions, pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/changeDisplayOrder", {
                stageIds,
                positions,
                pipelineId,
            });
        });
    }
    static getOpportunityCount(stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/getOpportunityCount", {
                stageId,
            });
        });
    }
}
